export enum CompareModes {
    GreaterThan,
    GreaterThanOrEqualTo,
    EqualTo,
    LessThanOrEqualTo,
    LessThan
}